import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WebAssetOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"web_asset_off"}/>
}
